export default {
  appName: "خدماتي بلس",
  welcome: "مرحباً بك",
  guestLogin: "الدخول كزائر",
  guestSubtitle: "تجربة التطبيق بالكامل بدون تسجيل",
  login: "تسجيل الدخول",
  phoneNumber: "رقم الجوال",
  enterOTP: "أدخل رمز التحقق",
  verify: "تحقق",
  home: "الرئيسية",
  services: "الخدمات",
  orders: "الطلبات",
  profile: "الحساب",
  nursing: "تمريض منزلي",
  cleaning: "تنظيف",
  plumbing: "سباكة",
  electrical: "كهرباء",
  maintenance: "صيانة أجهزة",
  urgentServices: "خدمات عاجلة",
  viewAll: "عرض الكل",
  bookNow: "احجز الآن",
  serviceDetails: "تفاصيل الخدمة",
  selectTime: "اختر الوقت",
  selectAddress: "اختر العنوان",
  problemDescription: "وصف المشكلة",
  uploadImages: "رفع صور إضافية",
  sendRequest: "إرسال الطلب",
  location: "الموقع",
  saveAddress: "حفظ العنوان",
  priceOffers: "عروض الأسعار",
  price: "السعر",
  arrivalTime: "وقت الوصول",
  rating: "التقييم",
  accept: "قبول",
  orderTracking: "متابعة الطلب",
  orderReceived: "تم استلام الطلب",
  onTheWay: "جاري التوجه",
  inProgress: "جاري العمل",
  completed: "مكتمل",
  payment: "الدفع",
  paymentMethods: "طرق الدفع",
  orderSummary: "ملخص الطلب",
  rateService: "تقييم الخدمة",
  rateTechnician: "تقييم الفني",
  submitRating: "إرسال التقييم",
  orderHistory: "سجل الطلبات",
  currentOrders: "الطلبات الحالية",
  previousOrders: "الطلبات السابقة",
  account: "الحساب",
  personalInfo: "البيانات الشخصية",
  darkMode: "الوضع الداكن",
  addresses: "العناوين",
  support: "الدعم الفني",
  logout: "تسجيل الخروج",
  sar: "ر.س",
  minutes: "دقيقة",
  searchServices: "ابحث عن خدمة...",
  popularServices: "الخدمات الشائعة",
  specialOffers: "عروض خاصة",
  guestMode: "وضع الزائر"
};
